import { API } from '@/api'
export async function getTeamInfo(teamResID: string) {
  const res: any = await API.getTeamInfo({ res_id: teamResID } as any)
  const limits = res?.team?.team?.profile?.limit ?? {}
  return {
    membersNumLimit: limits.membersNumLimit ?? 0,
    adminsNumLimit: limits.adminsNumLimit ?? 0,
    domain: res?.team?.team?.desc?.domainName,
  }
}

export async function getTeamMemberList(teamResID: string) {
  const res: any = await API.getTeamMemberList({ res_id: teamResID, page: 1, per_page: 100 } as any)
  return res
}
